/**
 * Tabs component for tabbed interfaces.
 */

import { useState, ReactNode } from 'react';
import { cn } from '@/utils/cn';
import './tabs.scss';

export interface Tab {
  id: string;
  label: string;
  icon?: ReactNode;
}

export interface TabsProps {
  tabs: Tab[];
  defaultTab?: string;
  children: (activeTab: string) => ReactNode;
}

export function Tabs({ tabs, defaultTab, children }: TabsProps) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  return (
    <div className="tabs">
      <div className="tabs__header" role="tablist">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={cn('tabs__tab', {
              'tabs__tab--active': activeTab === tab.id,
            })}
            role="tab"
            aria-selected={activeTab === tab.id}
            aria-controls={`tabpanel-${tab.id}`}
            id={`tab-${tab.id}`}
          >
            {tab.icon && <span className="tabs__tab-icon">{tab.icon}</span>}
            {tab.label}
          </button>
        ))}
      </div>
      <div
        className="tabs__content"
        role="tabpanel"
        id={`tabpanel-${activeTab}`}
        aria-labelledby={`tab-${activeTab}`}
      >
        {children(activeTab)}
      </div>
    </div>
  );
}

